export default {
  ZH_HK: {
    question: "請輸入問題",
    findImage: "查找和插入媒體",
    drag: "圖片拖動到這裡",
    or: "或",
    click: "點擊上傳",
    picture: "圖片",
    addQuestion: "添加答案",
    optional: "(可選)",
    optionalAnswer: "额外的答案",
    remove: "移除",
    add: "添加",
    sectionsQuestion: "分段提問",
    addTag: "添加標簽",
    questionError: "題目信息不完整",
    loading: "加載中...",
    singleChoiceErrorText: "此題型不可選中多個答案",
    saved: "已保存",
    input: "輸入",
    wholeQuestion: "整段提問",
    incompleteTitleInformation: "題目信息不完整",
    Addfailed: "失敗",
    Addsucceed: "成功",
    save: "保存",
    saveTips: "請把空白處填寫完整",
    selAnswer: "請選擇答案",
    title: "標題名稱",
    changeCover: "更換封面",
    coverUrl: "請上傳封面圖片",
    inputTitle: "請輸入標題名稱"
  },
  zh_cn: {
    question: "请输入问题",
    findImage: "查找和插入媒体",
    drag: "图片拖动到这里",
    or: "或",
    click: "点击上传",
    picture: "图片",
    addQuestion: "添加答案",
    optional: "(可选)",
    optionalAnswer: "额外的答案",
    remove: "移除",
    add: "添加",
    addTag: "添加标签",
    loading: "加载中...",
    singleChoiceErrorText: "此题型不可选中多个答案",
    questionError: "题目信息不完整",
    saved: "已保存",
    input: "输入",
    wholeQuestion: "整段提问",
    sectionsQuestion: "分段提问",
    incompleteTitleInformation: "题目信息不完整",
    Addfailed: "失败",
    Addsucceed: "成功",
    save: "保存",
    saveTips: "请把空白处填写完整",
    selAnswer: "请选择答案",
    title: "标题",
    changeCover: "更换封面",
    coverUrl: "请上传封面图片",
    inputTitle: "请输入标题名称"
  },
  EN: {
    question: "Please enter a question",
    findImage: "Find and insert media",
    drag: "Drag the picture here",
    or: "or",
    click: " Click to upload ",
    picture: "picture",
    addQuestion: "",
    optional: "Optional",
    optionalAnswer: " Additional Answers ",
    remove: "Remove",
    loading: "Loading...",
    add: "Add",
    input: "Input",
    wholeQuestion: "Whole paragraph question",
    saved: "Saved",
    addTag: "Add tag",
    questionError: "Incomplete title information",
    sectionsQuestion: "Segmented questioning",
    singleChoiceErrorText: "This topic cannot be selected for single-choice questions",
    incompleteTitleInformation: "Incomplete title information",
    Addfailed: "failed",
    Addsucceed: "success",
    save: "Save",
    saveTips: "Please fill in the blank space completely",
    selAnswer: "Please choose an answer",
    title: "Title",
    changeCover: "Change cover",
    coverUrl: "Please upload a cover image",
    inputTitle: "Please enter the title name"
  },
  es: {
    question: "Introduce la pregunta",
    findImage: "Buscar e insertar medios",
    drag: "Arrastra la imagen aquí",
    or: "o",
    click: "Haz clic para subir",
    picture: "Imagen",
    addQuestion: "Añadir respuesta",
    optional: "(Opcional)",
    optionalAnswer: "Respuesta adicional",
    remove: "Eliminar",
    add: "Añadir",
    sectionsQuestion: "Preguntas por secciones",
    addTag: "Añadir etiqueta",
    questionError: "La información de la pregunta está incompleta",
    loading: "Cargando...",
    singleChoiceErrorText: "Este tipo de pregunta no permite seleccionar múltiples respuestas",
    saved: "Guardado",
    input: "Introducir",
    wholeQuestion: "Pregunta completa",
    incompleteTitleInformation: "La información del título está incompleta",
    Addfailed: "Fallido",
    Addsucceed: "Éxito",
    save: "Guardar",
    saveTips: "Por favor, rellena los espacios en blanco",
    selAnswer: "Selecciona una respuesta",
    title: "Título",
    changeCover: "Cambiar portada",
    coverUrl: "Por favor, suba una imagen de portada",
    inputTitle: "Por favor, ingrese el nombre del título"
  }
};
